// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__16nbQ","col":"styles_col__3rsJG","fulfillmentStatus":"styles_fulfillmentStatus__vnRwh","emailCol":"styles_emailCol__1YD8C"};